import {object, string} from 'yup'

export const guideSchema = object({
    firstNameEng: string().required('required'),
    lastNameEng: string().required('required'),
    email: string().email('invalidEmail').required('required'),
})
